import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getDeployment } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getFullUrl } from '@/utils/amplitude/analytics/utils/getFullUrl';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

import { VipSurface } from './vipSurface';

type VipSignUpClickedPayload = TrackingPayload & {
    destinationUrl: string;
    surface: VipSurface;
};

const trackVipSignUpClickedAnalytics = (payload: VipSignUpClickedPayload) => {
    track(TrackingEvents.Vip.VipSignUpClicked, payload);
};

export const useTrackVipSignUpClickedAnalytics = () => {
    const deployment = useAppSelector(getDeployment);
    const { pathname } = useLocation();

    return useCallback(
        (destinationUrl: string) => {
            trackVipSignUpClickedAnalytics({
                destinationUrl,
                pageName: getAmplitudePageNameFromPath(pathname),
                surface: VipSurface.AccountSettings,
                url: getFullUrl(deployment, pathname),
            });
        },
        [deployment, pathname]
    );
};
